<div class="mission-list">
    <div class="m-section keep-left">
        <h3 i18n>What will you win?:</h3>
        <div class="prize-name" *ngFor="let prize of mission.prize"><img src="{{licenceService.getKey('icon-mission-completed')}}"> <span>{{prize.name}}</span></div>
    </div>
    <div class="wrapper">
        <h3 i18n>{{mission.name | removehtml}} games:</h3>
        <ul>
            <li *ngFor="let game of mission.games" (click)="launchGame(game.gameid,game.serviceName)">{{game.name}}</li>
        </ul>
    </div>
</div>